import { render, staticRenderFns } from "./externalview-layout.vue?vue&type=template&id=4ad44d92"
import script from "./externalview-layout.vue?vue&type=script&lang=js"
export * from "./externalview-layout.vue?vue&type=script&lang=js"
import style0 from "./externalview-layout.vue?vue&type=style&index=0&id=4ad44d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports